var map = {
	"./bridge_positive/translations/en/translation.json": 2488,
	"./criptokuantica/translations/en/translation.json": 1942,
	"./domum/translations/en/translation.json": 221,
	"./impozo/translations/en/translation.json": 5859
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7699;